export default function HowItWorksSection() {
  return (
    <div className="py-24 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-900 mb-16">
          Our Simple 4-Step Process
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="relative bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
              1
            </div>
            <div className="w-24 h-24 bg-teal-50 rounded-2xl flex items-center justify-center mb-6 mx-auto mt-4">
              <i className="ri-file-list-3-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Tell Us About Your Property</h3>
            <p className="text-gray-600 text-center leading-relaxed text-sm">
              Fill out our quick form with basic details about your property. No matter the condition, we want to hear from you.
            </p>
          </div>

          <div className="relative bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
              2
            </div>
            <div className="w-24 h-24 bg-teal-50 rounded-2xl flex items-center justify-center mb-6 mx-auto mt-4">
              <i className="ri-home-gear-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">We Evaluate Your Home</h3>
            <p className="text-gray-600 text-center leading-relaxed text-sm">
              Our team reviews your property and local market data. We can work from photos or schedule a quick walkthrough.
            </p>
          </div>

          <div className="relative bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
              3
            </div>
            <div className="w-24 h-24 bg-teal-50 rounded-2xl flex items-center justify-center mb-6 mx-auto mt-4">
              <i className="ri-money-dollar-circle-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Receive Your Cash Offer</h3>
            <p className="text-gray-600 text-center leading-relaxed text-sm">
              Get a fair, no-obligation cash offer within 24 hours. No pressure, no games - just a straightforward offer.
            </p>
          </div>

          <div className="relative bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-gray-900 text-white rounded-full flex items-center justify-center text-2xl font-bold shadow-lg">
              4
            </div>
            <div className="w-24 h-24 bg-teal-50 rounded-2xl flex items-center justify-center mb-6 mx-auto mt-4">
              <i className="ri-key-line text-5xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Close on Your Timeline</h3>
            <p className="text-gray-600 text-center leading-relaxed text-sm">
              Choose your closing date - as fast as 7 days or take your time. We handle all paperwork and closing costs.
            </p>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-teal-50 px-8 py-4 rounded-full">
            <i className="ri-time-line text-2xl text-teal-600"></i>
            <p className="text-gray-900 font-semibold">
              <span className="text-teal-600 text-xl font-bold">24 Hours</span> from submission to cash offer
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
